import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Search, Menu, X, Phone, ChevronRight } from "lucide-react";
import logo from "../../assets/logo-1.png";
import "./MainNav.css";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Window Repair", to: "/window-repair" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

function MainNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <>
      <nav className={`main-nav${scrolled ? " main-nav--scrolled" : ""}`}>
        <div className="container main-nav__inner">
          {/* Logo */}
          <Link
            to="/"
            className="main-nav__logo"
            onClick={() => setMobileOpen(false)}>
            {/* <img
              src={logo}
              alt="City Hardware logo"
              className="main-nav__logo-img"
            /> */}
            <span className="main-nav__logo-text">
              <span className="main-nav__logo-city">CITY</span>
              <span className="main-nav__logo-hardware">HARDWARE</span>
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <ul className="main-nav__links">
            {NAV_LINKS.map(({ label, to }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `main-nav__link${isActive ? " main-nav__link--active" : ""}`
                  }
                  end={to === "/"}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Right Actions */}
          <div className="main-nav__actions">
            <button
              className="main-nav__icon-btn"
              onClick={() => setSearchOpen(!searchOpen)}
              aria-label="Search">
              <Search size={20} />
            </button>

            <a
              href="tel:+13135828860"
              className="main-nav__cta-btn main-nav__cta-btn--outline">
              <Phone size={15} />
              Call Us
            </a>

            <Link
              to="/window-repair"
              className="main-nav__cta-btn main-nav__cta-btn--primary">
              Get a Quote
            </Link>

            <button
              className="main-nav__hamburger"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label={mobileOpen ? "Close menu" : "Open menu"}>
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Search Bar Dropdown */}
        <div
          className={`main-nav__search-panel${searchOpen ? " main-nav__search-panel--open" : ""}`}>
          <div className="container">
            <div className="main-nav__search-inner">
              <Search size={18} className="main-nav__search-icon" />
              <input
                type="text"
                placeholder="Search tools, supplies, or repair services…"
                className="main-nav__search-input"
                autoFocus={searchOpen}
              />
              <button
                className="main-nav__search-close"
                onClick={() => setSearchOpen(false)}
                aria-label="Close search">
                <X size={18} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div className={`mobile-menu${mobileOpen ? " mobile-menu--open" : ""}`}>
        <div className="mobile-menu__body">
          <ul className="mobile-menu__links">
            {NAV_LINKS.map(({ label, to }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className="mobile-menu__link"
                  onClick={() => setMobileOpen(false)}
                  end={to === "/"}>
                  {label}
                  <ChevronRight size={18} />
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="mobile-menu__actions">
            <Link
              to="/window-repair"
              className="mobile-menu__cta-primary"
              onClick={() => setMobileOpen(false)}>
              Get a Window Repair Quote
            </Link>
            <a href="tel:+13135828860" className="mobile-menu__cta-outline">
              <Phone size={16} />
              (313) 582-8860
            </a>
          </div>

          <div className="mobile-menu__info">
            <p>Detroit, Michigan</p>
            <p>Mon–Fri 9AM–6PM · Sat 9AM–5PM</p>
            <p>Closed Sunday</p>
          </div>
        </div>
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="mobile-menu__overlay"
          onClick={() => setMobileOpen(false)}
        />
      )}
    </>
  );
}

export default MainNav;
